var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.70725 9.68228L2.94058 11.349C2.81836 11.4267 2.69058 11.4601 2.55725 11.4489C2.42392 11.4378 2.30725 11.3934 2.20725 11.3156C2.10725 11.2378 2.02947 11.1405 1.97392 11.0236C1.91836 10.9067 1.90725 10.7763 1.94058 10.6323L2.67392 7.48228L0.223917 5.36562C0.112806 5.26562 0.0434728 5.15162 0.0159172 5.02362C-0.0116384 4.89562 -0.00341618 4.77073 0.0405838 4.64895C0.0850283 4.52673 0.151695 4.42673 0.240584 4.34895C0.329473 4.27117 0.451695 4.22117 0.60725 4.19895L3.84058 3.91562L5.09058 0.94895C5.14614 0.815617 5.23236 0.715617 5.34925 0.64895C5.46614 0.582284 5.58547 0.54895 5.70725 0.54895C5.82947 0.54895 5.94881 0.582284 6.06525 0.64895C6.18169 0.715617 6.26792 0.815617 6.32392 0.94895L7.57392 3.91562L10.8073 4.19895C10.9628 4.22117 11.085 4.27117 11.1739 4.34895C11.2628 4.42673 11.3295 4.52673 11.3739 4.64895C11.4184 4.77117 11.4268 4.89628 11.3993 5.02428C11.3717 5.15228 11.3021 5.26606 11.1906 5.36562L8.74058 7.48228L9.47392 10.6323C9.50725 10.7767 9.49614 10.9074 9.44058 11.0243C9.38503 11.1412 9.30725 11.2383 9.20725 11.3156C9.10725 11.3934 8.99058 11.4378 8.85725 11.4489C8.72392 11.4601 8.59614 11.4267 8.47392 11.349L5.70725 9.68228Z",
    fill: "#FFC23E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/RatingStar.a45b6fea29563a1a3dc32ff255127478.svg";
export { ForwardRef as ReactComponent };